export const getters = {
  GET_SHOPID (state) {
    return state.shopId
  },
  GET_SHOPINFO (state) {
    return state.shopInfo
  },
  GET_LEVEL (state) {
    return state.level
  },
  GET_THEME (state) {
    return state.theme
  },
  GET_BLOG (state) {
    return state.blog
  }
}



// WEBPACK FOOTER //
// ./src/store/shop/getters.js